import React from 'react';
import OpiCard from "../OpiCard/OpiCard";
import NoOpiCard from '../NoOpiCard/NoOpiCard';

export const IncidentColumn = (recentIncidents, loading, error) => {
  if (error || loading) return <OpiCard data={null} loading={loading} error={error}/>
  if (recentIncidents.length === 0) return <div className="col" key="no-opi"><NoOpiCard /></div>;
  return <div>{recentIncidents.map((item) => <OpiCard data={item} key={item.jiraId} loading={loading} error={error}/>)}</div>;
}; 
